<template>
  <div class="s_stationNewsMain">
    <card>
      <div class="form-info-box clearfix">
        <div class="form-check-info">
          <div>{{ $t("queryForm.userName") }}：<span>{{userName}}</span></div>
          <div>{{ $t("queryForm.companyEmail") }}：<span>{{companyEmail}}</span></div>
          <div>{{ $t("queryForm.roleName") }}：<span>{{roleName}}</span></div>
        </div>
      </div>
    </card>

    <el-tabs v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane :label="$t('homes.company')" name="0">
        <!-- 公司授权 -->
        <div class="userlist">
          <card v-if="gsShow">
            <form-table-page
              class="index-all-box"
              :data="formData"
              :label="formLabel"
              @Query="Query"
              @Reset="Reset"
            >
              <template slot="input1">
                <el-input v-model="formData.input1" :placeholder="$t('queryForm.pleaseEnter')"/>
              </template>

              <template slot="input2">
                <el-select v-model="formData.input2" :placeholder="$t('queryForm.pleaseSelect')">
                  <el-option
                    v-for="item in commonList"
                    :key="item.ids"
                    :label="item.text"
                    :value="item.ids"
                  />
                </el-select>
              </template>

              <!-- <template slot="input3">
                <el-select v-model="formData.input3" :placeholder="$t('queryForm.pleaseSelect')">
                  <el-option
                    v-for="item in regionList"
                    :key="item.ids"
                    :label="item.text"
                    :value="item.ids"
                  />
                </el-select>
              </template> -->

              <template slot="input3">
                <el-cascader v-model="formData.input3" :props="{value:'areaNo', label: 'name', children: 'underCity'}" :options="regionList" :placeholder="$t('queryForm.pleaseSelect')" />
              </template>

              <template slot="input4" >
                <el-radio v-model="formData.input4" label="1">{{ $t('administration.authorized') }}</el-radio>
                <el-radio v-model="formData.input4" label="2">{{ $t('administration.unauthorized') }}</el-radio>
              </template>

            </form-table-page>
          </card>

          <card style="margin-top:10px;">
          <div class="table-content-box">
            <table-page
              ref="table"
              :table-data="tableData"
              :total="total"
              :current-page="pageNum"
              :change-fun="changeTablePage"
              @selectionChange="handleSelectionChange"
            >
              <template slot="tableItem">
                <el-table-column
                  prop="tab1"
                  :label="$t('queryForm.companyName')"
                  align="center"
                  show-overflow-tooltip
                />

                <el-table-column
                  prop="tab2"
                  :label="$t('queryForm.technicalArea')"
                  align="center"
                  show-overflow-tooltip
                />
                  <!-- <template
                    slot-scope="scope"
                  >{{ commonList.filter(m=>{return m.ids===scope.row.tab2})[0].text }}</template>
                </el-table-column> -->

                <el-table-column
                  prop="tab3"
                  :label="$t('queryForm.headQuarter')"
                  align="center"
                  show-overflow-tooltip
                />

              </template>
            </table-page>
            <div class="pagesbtn">
              <el-form>
                <el-form-item class="line btn-box input-form-btn-list">
                  <!-- <el-button type="primary" plain @click="cancel">Cancel</el-button>
                  <el-button type="primary" round @click="saveBtn">Save</el-button> -->
                  <cus-btn type="cancel" @click="cancel()"></cus-btn>
                  <!-- <cus-btn type="authorize" @click="saveBtn()"></cus-btn> -->
                  <cus-btn v-show="gsbtn == '2'" type="assign" @click="saveBtn()" />
                  <cus-btn v-if="gsShow" v-show="gsbtn == '1'" type="revoke" @click="saveBtn()" />
                </el-form-item>
              </el-form>
            </div>

          </div>
          </card>
        </div>

      </el-tab-pane>
      <el-tab-pane :label="$t('homes.project')" name="1">
        <!-- 项目授权 -->
        <div class="userlist">
          <card v-if="gsShow">
            <form-table-page
              class="index-all-box"
              :data="formDataX"
              :label="formLabelX"
              @Query="QueryX"
              @Reset="Reset"
            >
              <template slot="input1">
                <el-input v-model="formDataX.input1" :placeholder="$t('queryForm.pleaseEnter')"/>
              </template>

              <template slot="input2">
                <el-input v-model="formDataX.input2" :placeholder="$t('queryForm.pleaseEnter')"/>
              </template>

              <template slot="input3">
                <el-select v-model="formDataX.input3" @change="asd" :placeholder="$t('queryForm.pleaseSelect')">
                  <el-option
                    v-for="item in commonList"
                    :key="item.ids"
                    :label="item.text"
                    :value="item.ids"
                  />
                </el-select>
              </template>

              <template slot="input4">
                <el-select v-model="formDataX.input4" :placeholder="$t('queryForm.pleaseSelect')">
                  <el-option
                    v-for="item in processList"
                    :key="item.ids"
                    :label="item.text"
                    :value="item.ids"
                  />
                </el-select>
              </template>

              <template slot="input5">
                <el-radio v-model="formDataX.input5" label="1">{{ $t('administration.authorized') }}</el-radio>
                <el-radio v-model="formDataX.input5" label="2">{{ $t('administration.unauthorized') }}</el-radio>
              </template>

            </form-table-page>
          </card>

          <card style="margin-top:10px;">
            <div class="table-content-box">

              <table-page
                ref="table"
                :table-data="tableDataX"
                :total="total"
                :current-page="pageNum"
                :change-fun="changeTablePageX"
                @selectionChange="handleSelectionChangeX"
              >
                <template slot="tableItem">
                  <el-table-column
                    prop="tab1"
                    :label="$t('queryForm.companyName')"
                    align="center"
                    show-overflow-tooltip
                  />

                  <el-table-column
                    prop="tab2"
                    :label="$t('queryForm.projectName')"
                    align="center"
                    show-overflow-tooltip
                  />

                  <el-table-column
                    prop="tab3"
                    :label="$t('queryForm.technicalArea')"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template
                      slot-scope="scope"
                    >{{ commonList.filter(m=>{return m.ids===scope.row.tab3}).length>0 ? commonList.filter(m=>{return m.ids===scope.row.tab3})[0].text : '' }}</template>
                  </el-table-column>

                  <el-table-column
                    prop="tab4"
                    :label="$t('administration.projectDevelopmentStatus')"
                    align="center"
                    show-overflow-tooltip
                  />

                </template>
              </table-page>
              <div class="pagesbtn">
                <el-form>
                  <el-form-item class="line btn-box input-form-btn-list">
                    <cus-btn type="cancel" @click="cancel()"></cus-btn>
                    <!-- <cus-btn type="authorize" @click="saveBtnX()"></cus-btn> -->
                    <cus-btn v-show="xmBtn == '2'" type="assign" @click="saveBtnX()" />
                    <cus-btn v-if="gsShow" v-show="xmBtn == '1'" type="revoke" @click="saveBtnX()" />
                    <!-- <el-button type="primary" plain @click="cancel">Cancel</el-button> -->
                    <!-- <el-button type="primary" round @click="saveBtnX">Save</el-button> -->

                  </el-form-item>
                </el-form>
              </div>

            </div>
          </card>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import { dictGetDataType, areaSelectList, userAuthorizeCompany, baseProcessSelectStage, userIsCoverProject, userAuthorizeProject, roleselectUser, baseEnumsSelectAreaNo } from '../../api/adminManagement'
import { userGetPermissionCompany,  userGetPermissionProject } from '../../api/patentManagement'
export default {
  data() {
    return {

      multipleSelection: [],
      tableData: [],

      pageSize: 10,
      pageNum: 1,
      total: 0,

      formData: {
        input1: '',
        input2: '',
        input3: '',
        input4: '2'
      },
      formLabel: {
        input1: 'queryForm.companyName',
        input2: 'queryForm.technicalArea',
        input3: 'queryForm.headQuarter',
        input4: {name: 'queryForm.status', isNoFixedWidth: true}
      },
      commonList: [],
      regionList: [],

      formDataX: {
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '2'
      },
      formLabelX: {
        input1: 'queryForm.companyName',
        input2: 'queryForm.projectName',
        input3: 'queryForm.technicalArea',
        input4: 'administration.projectDevelopmentStatus',
        input5: {name: 'queryForm.status', isNoFixedWidth: true}
      },
      tableDataX: [],
      processList: [],
      multipleSelectionX: [],
      userName:'',
      companyEmail:'',
      roleName:'',
      gsbtn:'1',
      xmBtn:'1',
      activeName:'0',
      gsShow:true


    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    },
    
  },
  watch: {
    lang() {
      this.getbaseEnumsSelectCommon()
      this.getregionSelectCommon()
      this.companyEmpower(this.pageNum, this.$refs.table.pageSize, this.$refs.table.queryData)
    }
  },
  mounted() {
    
    if(this.$route.params.type == '2'){
      this.gsShow = false
    }
    this.userName = this.$route.params.uname;
    this.companyEmail= this.$route.params.uemail;
    this.roleName= this.$route.params.uarrname;
    
    // this.roleselectUserlist()
    this.getbaseEnumsSelectCommon()
    this.getregionSelectCommon()
    this.Query()
    // 项目授权的
    // this.QueryX()
  },
  methods: {

    /**
     * 查询方法  公司授权
     * @constructor
     */
    Query(type) {
      this.pageNum = 1
      this.companyEmpower(1, this.$refs.table.pageSize)
    },

    changeTablePage(currentPage, pageSize) {
      this.pageNum = currentPage
      this.$refs.table.pageSize = pageSize
      this.companyEmpower(currentPage, pageSize, this.$refs.table.queryData)
    },

    /**
     * 查询方法  项目授权
     * @constructor
     */
    QueryX(type) {
      this.pageNum = 1
      this.projectEmpower(1, this.$refs.table.pageSize)
    },

    changeTablePageX(currentPage, pageSize) {
      this.pageNum = currentPage
      this.$refs.table.pageSize = pageSize
      this.projectEmpower(currentPage, pageSize, this.$refs.table.queryData)
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      this.pageNum = 1
      // console.log('重置')
    },

    /**
     * 调转到查看页面
     */
    openViewPage() {
      this.$router.push({
        name: 'companyInfoView'
      })
    },

    /**
     * 监听分页
     */
    handleSearch(currentPage) {
      // console.log("22222", currentPage);
      this.fetchRemoteData(
        currentPage,
        this.$refs.table.pageSize,
        this.$refs.table.queryData
      )
    },

    handleClick(tab, event) {
      // console.log(tab);
      this.tableData = []
      this.total = 0
      if( tab.index == '0' ){
        this.pageNum = 1
        this.companyEmpower(1, this.$refs.table.pageSize)
      }else if( tab.index == '1' ){
        this.pageNum = 1
        this.projectEmpower(1, this.$refs.table.pageSize)
      }

      


    },

      /**
     * 返回上一页
     */
    cancel() {
      this.$router.push({
        name: 'patentListViewEmpower'
      })
    },

    /**
     * table 选中事件
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectionChangeX(val) {
      this.multipleSelectionX = val
    },

    // 获取技术领域下拉列表
    // roleselectUserlist() {
    //   const self = this
    //   roleselectUser({}).then(response => {
    //     if (response.code === 200) {
    //       let roleNameList = ''
    //       for( let i = 0; i<response.data.length; i++ ){
    //         roleNameList += response.data[i].name + ' '
    //       }
    //       this.roleName= roleNameList
    //     }
    //   })
    // },


    // 获取技术领域下拉列表
    getbaseEnumsSelectCommon() {
      const self = this
      self.commonList = []
      let invoicetypeMap = {}
      dictGetDataType({type:'1'}).then(response => {
        if (response.code === 200) {
          response.data.forEach(item => {
            invoicetypeMap = {
              text: item.value,
              ids: item.key
            }
            self.commonList.push(invoicetypeMap)
          })
        }
      })
    },

    // 获取总部下拉列表
    getregionSelectCommon() {
      const self = this
      self.regionList = []
      let invoicetypeMap = {}
      baseEnumsSelectAreaNo({}).then(response => {
        if (response.code === 200) {
          // response.data.forEach(item => {
          //   invoicetypeMap = {
          //     text: item.areaName,
          //     ids: item.areaNo
          //   }
          //   self.regionList.push(invoicetypeMap)
          // })
          self.regionList = response.data
        }
      })
    },

    // 获取地区数据信息
    getprocessSelectCommon(key) {
      const self = this
      self.processList = []
      let invoicetypeMap = {}
      baseProcessSelectStage({ technicalArea: key }).then(response => {
        if (response.code === 200) {
          response.data.forEach(item => {
            invoicetypeMap = {
              text: item.stageName,
              ids: item.code
            }
            self.processList.push(invoicetypeMap)
          })
        }
      })
    },

    asd(key) {
      this.formDataX.input4 = ""
      this.getprocessSelectCommon(key)
    },

    // 公司授权列表
    companyEmpower(currentPage, pageSize, queryData) {
      const self = this
      // console.log(self.formData.input3)
      this.gsbtn = self.formData.input4
      if (!queryData) {
        queryData = {
          pageNum: currentPage,
          pageSize: pageSize,
          authorized: self.formData.input4, // 是否授权
          choosedUserId: this.$route.params.id, // 用户id
          companyName: self.formData.input1, // 公司名称
          technicalArea: self.formData.input2, // 技术领域
          headQuarter: self.formData.input3 && self.formData.input3.length == 2 ? self.formData.input3[0]+','+self.formData.input3[1] : '' // 总部

        }
      } else {
        queryData.pageNum = currentPage
        queryData.pageSize = pageSize
      }
      userGetPermissionCompany(queryData)
        .then(response => {
          if (response.code === 200) {
            if (response.data && response.data.list) {
              self.tableData = []
              for (let i = 0; i < response.data.list.length; i++) {
                let obj = {}
                obj = {
                  ids: response.data.list[i].companyId,
                  tab1: response.data.list[i].companyName,
                  tab2: response.data.list[i].tAreaSplicing,
                  tab3: response.data.list[i].hQuarterSplicing
                }
                self.tableData.push(obj)
              }
              this.total = response.data.total
            } else {
              this.tableData = []
              this.total = 0
            }
            // 保存当前查询条件
            this.$refs.table.queryData = queryData
          }
        })
    },

    // 公司数据授权
    saveBtn() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: this.$t("queryForm.pleaseSelect"),
          type: 'warning'
        })
        return
      } else {
        const self = this
        let txt = ''
        if (self.formData.input4 == 1) {
          txt = this.$t("administration.authorizationbatch")
        } else {
          txt = this.$t("administration.authorizationnot")
        }
        this.$confirm(txt, this.$t("checkList.tips"), {
          confirmButtonText: this.$t("checkList.confirm"),
          cancelButtonText: this.$t("checkList.cancel"),
          type: 'warning'
        }).then(() => {
          const idd = []
          for (let i = 0; i < this.multipleSelection.length; i++) {
            idd[i] = this.multipleSelection[i].ids
          }
          const param = {
            companyIds: idd,
            operationType: self.formData.input4 == '1' ? '2' : '1',
            userId: this.$route.params.id
          }
          userAuthorizeCompany(param)
            .then(response => {
              if (response.code === 200) {
                this.$message({
                  type: 'success',
                  message: response.message
                })
                this.Query()
              }
            })
        }).catch(() => {})
      }
    },

    // 项目授权
    saveBtnX() {
      if (this.multipleSelectionX.length == 0) {
        this.$message({
          message: this.$t('queryForm.pleaseSelect'),
          type: 'warning'
        })
        return
      } else {
        const self = this
        let txt = ''
        if (self.formDataX.input5 == 1) {
          txt = this.$t('administration.authorizationbatch')
        } else {
          txt = this.$t('administration.authorizationnot')
        }
        this.$confirm(txt, this.$t('messageCommon.tips'), {
          confirmButtonText: this.$t('checkList.confirm'),
          cancelButtonText: this.$t('checkList.cancel'),
          type: 'warning'
        }).then(() => {
          const idd = []
          const iddx = []
          for (let i = 0; i < this.multipleSelectionX.length; i++) {
            idd[i] = this.multipleSelectionX[i].ids
            iddx[i] = { companyId: this.multipleSelectionX[i].idx, projectId: this.multipleSelectionX[i].ids }
          }
          if (self.formDataX.input5 == 1) {
            const param = {
              projectList: iddx,
              operationType: self.formDataX.input5 == '1' ? '2' : '1',
              userId: this.$route.params.id
            }
            userAuthorizeProject(param)
              .then(response => {
                if (response.code === 200) {
                  this.$message({
                    type: 'success',
                    message: response.message
                  })
                  this.QueryX()
                }
              })
          } else {
            const param = {
              companyIds: idd,
              operationType: self.formDataX.input5 == '1' ? '2' : '1',
              userId: this.$route.params.id
            }
            userIsCoverProject(param)
              .then(response => {
                if (response.code === 200) {
                  // this.$message({
                  //   type: 'success',
                  //   message: response.message
                  // });
                  // this.QueryX();
                  if (response.data) {
                    this.$confirm(this.$t('administration.confirmtooverwrite'), this.$t('messageCommon.tips'), {
                      confirmButtonText: this.$t('checkList.confirm'),
                      cancelButtonText: this.$t('checkList.cancel'),
                      type: 'warning'
                    }).then(() => {
                      const param = {
                        projectList: iddx,
                        operationType: self.formDataX.input5 == '1' ? '2' : '1',
                        userId: this.$route.params.id
                      }
                      userAuthorizeProject(param)
                        .then(response => {
                          if (response.code === 200) {
                            this.$message({
                              type: 'success',
                              message: response.message
                            })
                            this.QueryX()
                          }
                        })
                    }).catch(() => {})
                  } else {
                    const param = {
                      projectList: iddx,
                      operationType: self.formDataX.input5 == '1' ? '2' : '1',
                      userId: this.$route.params.id
                    }
                    userAuthorizeProject(param)
                      .then(response => {
                        if (response.code === 200) {
                          this.$message({
                            type: 'success',
                            message: response.message
                          })
                          this.QueryX()
                        }
                      })
                  }
                }
              })
          }
        }).catch(() => {})
      }
    },

    // 项目授权列表
    projectEmpower(currentPage, pageSize, queryData) {
      const self = this
      this.xmBtn = self.formDataX.input5
      if (!queryData) {
        queryData = {
          pageNum: currentPage,
          pageSize: pageSize,
          authorized: self.formDataX.input5, // 是否授权
          choosedUserId: this.$route.params.id, // 用户id
          companyName: self.formDataX.input1, // 公司名称
          technicalArea: self.formDataX.input3, // 技术领域
          projectName: self.formDataX.input2, // 项目名称
          developmentStatusCode: self.formDataX.input4 // 流程状态
        }
      } else {
        queryData.pageNum = currentPage
        queryData.pageSize = pageSize
      }
      userGetPermissionProject(queryData)
        .then(response => {
          if (response.code === 200) {
            if (response.data && response.data.list) {
              self.tableDataX = []
              for (let i = 0; i < response.data.list.length; i++) {
                let obj = {}
                obj = {
                  ids: response.data.list[i].projectId,
                  idx: response.data.list[i].companyId,
                  tab1: response.data.list[i].companyName,
                  tab2: response.data.list[i].peojectName,
                  tab3: response.data.list[i].technicalArea,
                  tab4: response.data.list[i].developmentStatusName
                }
                self.tableDataX.push(obj)
              }
              this.total = response.data.total
            } else {
              this.tableDataX = []
              this.total = 0
            }
            // 保存当前查询条件
            this.$refs.table.queryData = queryData
          }
        })
    }

  }
}
</script>

<style lang="scss">
  .s_stationNewsMain{
    .form-check-info div{
      width: 33%;
    }
    .el-tabs__nav-wrap::after{
      background-color:transparent!important;
    }
    .el-tabs__active-bar{
      width: 50px!important;
      height: 4px!important;
    }
    .el-tabs__header{
      margin: 20px 0 20px 0;
    }
    .el-tabs__item{
      font-size: 20px;
    }

    .searchList{
      margin-bottom: 30px;
      display: flex;
      justify-content:flex-start;
      align-items:flex-end;
      .searchTitle{
        line-height: 40px;
        font-size: 14px;
      }
      .searchTxt{
        font-size: 14px;
        display: inline-block;
        width: 600px;
        input{
          -webkit-appearance: none;
          background-color: #FFF;
          background-image: none;
          border-radius: 4px;
          border: 1px solid #DCDFE6;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: #606266;
          display: inline-block;
          font-size: inherit;
          height: 40px;
          line-height: 40px;
          outline: 0;
          padding: 0 15px;
          -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
          transition: border-color .2s cubic-bezier(.645,.045,.355,1);
          width: 100%;
        }
      }
      .searchBtn{
        margin-left: 60px;
      }
    }
    .el-card__body{
      padding:25px 52px 25px 52px ;

    }
    .el-card{
      margin-bottom: 20px;
    }
    .cardMain{
      position: relative;
      i{
        width: 12px;
        height: 12px;
        background:#FE0000;
        display: inline-block;
        position: absolute;
        left: -20px;
        top: -6px;
        border-radius: 50%;
      }
      .cardTitle{
        display: flex;
        justify-content:space-between;
        font-size: 18px;
        margin-bottom: 18px;
        .cardTitle_ttile{
          font-weight: bold;
        }
        .cardTitle_time{
          color: #999999;
        }
      }
      .cardTxt{
        font-size: 18px;
        color: #666666;
      }
    }
    .pagesbtn{
      padding-top: 50px;
    }

  }

</style>
